(function () {
  const map = new Map([
    ['主页', 'Home'],
    ['产品目录', 'Shop'],
    ['联系我们', 'Contact']
  ]);
  function normalize(root) {
    (root || document).querySelectorAll('a').forEach((a) => {
      const t = a.textContent.trim();
      if (map.has(t)) a.textContent = map.get(t);
    });
    (root || document).querySelectorAll('input[type="email"]').forEach((input) => {
      if (input.placeholder === '电子邮件地址') input.placeholder = 'Email address';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => normalize(document));
  else normalize(document);
  new MutationObserver((muts) => muts.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) normalize(n); }))).observe(document.documentElement, {childList:true, subtree:true});
})();
